/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Info Terraformlockout";
const frontMatter = {};
import {Alert} from '@/components';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return <Alert severity="info"><_components.p>{"Users can modify Terraform-managed resources only by using Terraform.\n"}<_components.a href="/tooling/infrastructure/terraform#prevent-changes-to-managed-resources">{"Learn more"}</_components.a>{"."}</_components.p></Alert>;
}

export default MDXLayout